export default __webpack_public_path__ + "static/media/login_background.4e5dced7.png";